import { stringifyGraph } from '@/clients/http'
import { OrderNoteModel } from '@/http/models/OrderNote'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { OrderNoteHttpParams, OrderNoteModel as OrderNoteType } from '@/types'

export interface OrderNoteListFilters {
  search?: string
}

export interface OrderNoteListForm extends UseFetchListForm<
  OrderNoteListFilters,
  OrderNoteType.OrderNote
> {}

interface UseFetchOrderNotesProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const orderNoteInitialFilters: OrderNoteListFilters = {
  search: '',
}

export const useFetchOrderNotes = ({ sort, shouldFetchList }: UseFetchOrderNotesProps) => {
  return useFetchList<
    OrderNoteListFilters,
    OrderNoteType.OrderNote,
    {},
    any,
    typeof OrderNoteModel.getList
  >({
    pageSize: 10,
    initialFilters: orderNoteInitialFilters,
    fetchFunction: OrderNoteModel.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<OrderNoteHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      graph_enc: stringifyGraph({
        '*': true,
        'orders.count': true,
      }),
    }),
    buildParams: () => ({}),
  })
}
